'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { ApiPriceInformation } from '../../../api/model';

const SinglePriceInfo = dynamic(() => import('@/components/priceInformation/SinglePriceInfo'));

const SinglePriceInfoClientImporter: FC<{
  singlePriceInformation: Partial<ApiPriceInformation>;
}> = (props): JSX.Element => {
  return <SinglePriceInfo {...props} />;
};

export default SinglePriceInfoClientImporter;
